import React from 'react';
import { MetaText } from "@hm-group/fabric-components/components/Typography";
import cn from 'classnames';
import "./NewProductMarker.css";
var styles = { "newProduct": "de86fe", "hm": "a08a31", "northstar-small": "ab710a", "northstar-large": "de581e" };
const NewProductMarker = ({ isNewProduct, newProductLabel, variant = 'hm' }) => {
    if (!isNewProduct)
        return null;
    return (React.createElement(MetaText, { Tag: "p", className: cn(styles.newProduct, styles[variant]), hasEllipsis: true }, newProductLabel));
};
export default NewProductMarker;
//# sourceMappingURL=NewProductMarker.js.map